export const serviceAuthorisationConfig = {
    id: 'service-authorisation',
    initial: 'draft',
    states: {
        draft: {
            on: { SUBMIT: { target: 'pending_approval', guard: 'hasValidServices' } },
        },
        pending_approval: {
            on: {
                APPROVE: { target: 'active', guard: 'hasApproverSignature' },
                REJECT: { target: 'rejected', guard: 'hasRejectionReason' },
            },
        },
        active: {
            on: {
                REVOKE: { target: 'revoked', guard: 'hasRevocationReason' },
                EXPIRE: 'expired',
            },
        },
        rejected: { type: 'final' },
        revoked: { type: 'final' },
        expired: { type: 'final' },
    },
};
//# sourceMappingURL=service-authorisation.js.map